import PubSub from "underpub-js";

var FooterCenter = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-FooterCenter',
	};

	$.extend(true, this.options, options);

};

FooterCenter.prototype.init = function() {

	var self = this;

};

export default FooterCenter;
